import { useMemo, useSyncExternalStore } from 'react';
import { readDeviceDisplayContext, resolveDisplayContext } from '@liquid-spirit/date-time/display';
import { useAuthContext } from '../contexts/AuthContext';

const listeners = new Set();
let device = readDeviceDisplayContext();
function refresh() {
  let next;
  try { next = readDeviceDisplayContext(); } catch { return; } // Retain the last valid OS snapshot during a failed refresh.
  if (JSON.stringify(next) === JSON.stringify(device)) return;
  device = next;
  listeners.forEach(listener => listener());
}
function subscribe(listener) {
  listeners.add(listener);
  // Synchronize with browser focus and OS timezone/locale changes, including
  // changes made while this tab remains visible. One subscription serves all rows.
  if (listeners.size === 1) {
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    subscribe.timer = window.setInterval(refresh, 60000);
    refresh();
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
      window.clearInterval(subscribe.timer);
    }
  };
}
const snapshot = () => device;

export default function useDateTimeDisplay() {
  const { user } = useAuthContext();
  const currentDevice = useSyncExternalStore(subscribe, snapshot, snapshot);
  const preference = user?.dateTimePreferences;
  const display = useMemo(() => resolveDisplayContext(preference, currentDevice), [preference, currentDevice]);
  return { device: currentDevice, display };
}
